angular.module('edxResources', []);